// extracted by mini-css-extract-plugin
export default {"outer":"MainContainer_outer__WC3TQ","inner":"MainContainer_inner__6l8W8","mainContainerChildren":"MainContainer_mainContainerChildren__1kAgI"};